var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"grey lighten-4",attrs:{"img":_vm.app.bkBuscador}},[_c('v-card-text',[(_vm.ready)?_c('BuscadorTarifario',{attrs:{"plano":_vm.$vuetify.breakpoint.smAndDown ? 'column' : 'row'}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }